export default "__VITE_ASSET__B4IrZO4Y__"